export function normalizeSSN(value: string): string {
  return (value ?? '')
    .toString()
    .replace(/\s/g, '')
    .replace(/[^0-9AB]/g, '')
    .substring(0, 15);
}

export function formatSSN(value: string): string {
  const normalized = normalizeSSN(value);
  let formatted = '';
  if (normalized.length > 0) formatted += normalized.substring(0, 1);
  if (normalized.length > 1) formatted += ' ' + normalized.substring(1, 3);
  if (normalized.length > 3) formatted += ' ' + normalized.substring(3, 5);
  if (normalized.length > 5) formatted += ' ' + normalized.substring(5, 7);
  if (normalized.length > 7) formatted += ' ' + normalized.substring(7, 10);
  if (normalized.length > 10) formatted += ' ' + normalized.substring(10, 13);
  if (normalized.length > 13) formatted += ' ' + normalized.substring(13, 15);
  return formatted;
}
